





































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class PageContent extends Vue {
  @Prop() private pageTitle: string;
  @Prop() private pageTitleHtml: string;
  @Prop() private headerFixed: boolean;
  @Prop() private footerFixed: boolean;
  @Prop() private icon: string;
  @Prop() private contentStyle: string;

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }
}
